import React from 'react';

import { Image, Space, Tag, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';

import { SystemSlugs } from '@app/models/dictionaries';
import { ViewProductInCatalogSchema } from '@app/models/products';
import { DictionaryPostfix } from '@components/DictionaryPostfix';

export const BASE_COLUMNS: ColumnsType<ViewProductInCatalogSchema> = [
  {
    title: 'articul',
    dataIndex: 'code',
    key: 'code',
    width: 100,
    ellipsis: true,
  },
  {
    width: 100,
    title: 'images',
    dataIndex: 'images',
    key: 'images',
    render: (_, product) => (
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}>
        {product?.images.length ? (
          <Image.PreviewGroup items={product.images.map((el) => el.variants.fullscreen?.url || '')}>
            <Image src={product.images?.[0]?.variants?.thumbnailSmall?.url} />
          </Image.PreviewGroup>
        ) : (
          ''
        )}
      </div>
    ),
  },
  {
    width: 100,
    title: 'title',
    dataIndex: 'title',
    key: 'title',
  },
  {
    width: 100,
    title: 'brand',
    dataIndex: 'brand',
    key: 'brand',
    render: (_, product) => product?.brand?.title,
  },
  {
    width: 200,
    title: 'categories',
    dataIndex: 'category',
    key: 'category',
    render: (_, product) => product.category?.title,
  },
  {
    width: 200,
    title: 'tags',
    dataIndex: 'tags',
    key: 'tags',
    render: (_, product) => (
      <Space size={10} wrap>
        {product?.tags?.map((el, i) => (
          <Tag key={i} style={{ margin: 0 }}>
            {el.title}
          </Tag>
        ))}
      </Space>
    ),
  },
  {
    width: 100,
    align: 'center',
    title: 'multiplicity',
    dataIndex: 'package_amount',
    key: 'package_amount',
  },
  {
    width: 100,
    title: 'price',
    align: 'center',
    dataIndex: 'price',
    key: 'price',
    render: (_, product) => (
      <Typography.Text style={{ margin: 0 }}>
        {product.price || 0} <DictionaryPostfix dictionaryType={SystemSlugs.Currencies} />
      </Typography.Text>
    ),
  },
  {
    width: 100,
    align: 'center',
    title: 'available_stock',
    dataIndex: 'available_stock',
    key: 'available_stock',
    render: (_, product) => {
      const availableStock = product.available_stock ?? 0;
      return <Typography.Text style={{ margin: 0 }}>{availableStock}</Typography.Text>;
    },
  },
];
